import { composeStateMachine } from '../../../module';

import { ReportCreateState } from '../records';

import { EditableReport } from '../../common/forms/reportForm/records';
import { reportFormActions } from '../../common/forms/reportForm/state';

export const reportCreateInitialState = ReportCreateState();

export const reportCreateState = composeStateMachine('REPORTS-REPORT-NEW', reportCreateInitialState, (compose) => ({
  ...reportFormActions(compose, 'newReport'),

  updateReportViewId: compose.action((state, viewId: string) =>
    state.update('newReport', (newReport) => newReport.set('lensId', null).set('viewId', viewId))
  ),

  updateReportLensId: compose.action((state, lensId: string) =>
    state.update('newReport', (newReport) => newReport.set('lensId', lensId).set('viewId', null))
  ),

  resetReportCreateState: compose.payloadlessAction((state) => state.set('newReport', EditableReport)),

  updateReportParentFolderId: compose.action((state, parentFolderId?: number | null) =>
    state.update('newReport', (newReport) => newReport.set('parentFolderId', parentFolderId))
  )
}));

export const {
  actions: reportCreateActions,
  actionCreators: reportCreateActionCreators,
  reducer: reportCreateReducer,
  selector: reportCreateSelector
} = reportCreateState;
